import styled from 'styled-components';

export const Container = styled.div`
    grid-area: HH;
    width: 100%;
    padding-top: 3rem;
    padding-bottom: 2rem;
`;
